module.exports = __webpack_public_path__ + "img/wallet_02_advanced_2.80918261.png";